class DataCacheService {
    constructor() {
        this.data = {};
    }

    set(key, val) {
        this.data[key] = val;
        return val;
    }

    get(key) {
        return this.data[key];
    }

    del(key) {
        delete this.data[key];
    }

    has(key) {
        return (key in this.data);
    }

    delMatching(str) {
        for (const key in this.data) {
            if (key.indexOf(str) !== -1)
                delete this.data[key];
        }
    }

    reset() {
        this.data = {};
    }
}

export default new DataCacheService();
